import { env } from '../config/env';
import { getSupabase, writeSessionRow } from './supabaseClient';
import type { SessionRow } from './types';
import { devWarn } from '../lib/devLog';

/**
 * Session logging — the reporting fields only, no media and no phone number.
 * Funnel drop-off, UTM performance, mic denial rate, completion.
 *
 * Writes onto the same `sessions` row the kiosk queue writes to, via
 * `writeSessionRow` — insert, then update on a duplicate. Only the columns in
 * the payload are sent, so the two writers do not clobber each other and order
 * does not matter. See writeSessionRow for why this is not an upsert.
 *
 * Fire and forget in both modes. A logging failure is never a guest-facing
 * problem, and on the kiosk the delivery queue is the thing that has to be
 * durable, not the analytics row.
 */

export function logSession(row: SessionRow): void {
  if (!env.sessionLoggingEnabled) return;

  void (async () => {
    try {
      const supabase = await getSupabase();
      if (!supabase) return;
      const { error } = await writeSessionRow(supabase, row);
      if (error) devWarn('[sessionLog] failed (ignored)', error.message);
    } catch (err) {
      devWarn('[sessionLog] failed (ignored)', err);
    }
  })();
}
